import { FC, ReactNode } from 'react';
import { Stack } from '@mui/material';

interface Props {
  children: ReactNode;
}

const PageHeader: FC<Props> = ({ children }) => {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2} gap={8}>
      {children}
    </Stack>
  );
};

export default PageHeader;
